import MANAGERS from './managers';
import PERMISSIONS from './permissions';
import SUPER_MANAGERS from './superManagers';
import TRAINERS from './trainers';
import ATHLETES from './athletes';
import GYMS from './gyms';
import GROUPS from './groups';
import CLUBS from './clubs';
import COMMON from './common';
import CONTRIBUTIONS from './contributions';
import PARENTS from './parents';
import ACTIVITIES from './activities';
import USERS from './users';
import CERTIFICATION from './certification';
import CERTIFICATION_ATHLETE from './certifications_athlete';
import STATEMENT from './statement';
import PROTOCOLS from './protocols';
import STATISTICS from './statistics';

const schema = {
  managers: {
    many: () => [MANAGERS.manyQuery, 'managers'],
    one: () => [MANAGERS.oneQuery, 'manager'],
    create: () => [MANAGERS.createMutation, 'createManager'],
    update: () => [MANAGERS.updateMutation, 'updateManager'],
    delete: () => [MANAGERS.deleteMutation, 'deleteManager'],
  },
  superManagers: {
    many: () => [SUPER_MANAGERS.manyQuery, 'superManagers'],
    one: () => [SUPER_MANAGERS.oneQuery, 'superManager'],
    create: () => [SUPER_MANAGERS.createMutation, 'createSuperManager'],
    update: () => [SUPER_MANAGERS.updateMutation, 'updateSuperManager'],
    delete: () => [SUPER_MANAGERS.deleteMutation, 'deleteSuperManager'],
  },
  trainers: {
    many: () => [TRAINERS.manyQuery, 'trainers'],
    one: () => [TRAINERS.oneQuery, 'trainer'],
    archivate: () => [TRAINERS.archivateMutation, 'archivateTrainer'],
    activate: () => [TRAINERS.activateMutation, 'activateMutation'],
    create: () => [TRAINERS.createMutation, 'createTrainer'],
    update: () => [TRAINERS.updateMutation, 'updateTrainer'],
    delete: () => [TRAINERS.deleteMutation, 'deleteTrainer'],
  },
  certifications: {
    many: () => [CERTIFICATION.manyQuery, 'certifications'],
    one: () => [CERTIFICATION.oneQuery, 'certificate'],
    create: () => [CERTIFICATION.createMutation, 'createCertifications'],
    update: () => [CERTIFICATION.updateMutation, 'updateCertifications'],
    close: () => [CERTIFICATION.closeMutation, 'closeCertifications'],
    open: () => [CERTIFICATION.openMutation, 'openCertifications'],
    delete: () => [CERTIFICATION.deleteMutation, 'deleteCertifications'],
    undelete: () => [CERTIFICATION.undeleteMutation, 'undeleteCertifications'],
    generateProfileInfo: () => [
      CERTIFICATION.generateProfileInfoMutation,
      'generateCertificationsPdf',
    ],
  },
  certifications_athlete: {
    many: () => [CERTIFICATION_ATHLETE.manyQuery, 'certificationsAthletes'],
    one: () => [CERTIFICATION_ATHLETE.oneQuery, 'certificationsAthlete'],
    create: () => [
      CERTIFICATION_ATHLETE.createMutation,
      'createCertificationsAthletes',
    ],
    update: () => [
      CERTIFICATION_ATHLETE.updateMutation,
      'updateCertificationsAthletes',
    ],
    open: () => [CERTIFICATION_ATHLETE.openMutation, 'openStatement'],
    close: () => [CERTIFICATION_ATHLETE.closeMutation, 'closeStatement'],
    closeProtocol: () => [
      CERTIFICATION_ATHLETE.closeProtocolMutation,
      'closeProtocol',
    ],
    done: () => [CERTIFICATION_ATHLETE.doneMutation, 'doneAthleteRank'],
    undone: () => [CERTIFICATION_ATHLETE.undoneMutation, 'undoneAthleteRank'],
    delete: () => [
      CERTIFICATION_ATHLETE.deleteMutation,
      'deleteCertificationsAthletes',
    ],
    generateProfileInfo: () => [
      CERTIFICATION_ATHLETE.generateProfileInfoMutation,
      'generateProtocolPdf',
    ],
  },
  statement: {
    many: () => [STATEMENT.manyQuery, 'statement'],
    delete: () => [STATEMENT.deleteMutation, 'deleteStatement'],
  },
  protocols: {
    many: () => [PROTOCOLS.manyQuery, 'protocols'],
    delete: () => [PROTOCOLS.deleteMutation, 'deleteProtocol'],
  },
  statistics: {
    many: () => [STATISTICS.manyQuery, 'statistics'],
    delete: () => [STATISTICS.deleteMutation, 'deleteProtocol'],
  },
  athletes: {
    many: () => [ATHLETES.manyQuery, 'athletes'],
    one: () => [ATHLETES.oneQuery, 'athlete'],
    create: () => [ATHLETES.createMutation, 'createAthlete'],
    update: () => [ATHLETES.updateMutation, 'updateAthlete'],
    delete: () => [ATHLETES.deleteMutation, 'deleteAthlete'],
    block: () => [ATHLETES.blockMutation, 'blockAthlete'],
    archivate: () => [ATHLETES.archivateMutation, 'archivateAthlete'],
    activate: () => [ATHLETES.activateMutation, 'activateMutation'],
    changeGroup: () => [ATHLETES.changeGroupMutation, 'updateAthleteGroup'],
    addToGroup: () => [ATHLETES.addAthleteToGroupMutation, 'addAthleteToGroup'],
    setUserTypes: () => [ATHLETES.setUserTypesMutation, 'setUserTypes'], // it is common for all users
    generateProfileInfo: () => [
      ATHLETES.generateProfileInfoMutation,
      'generateProfileInfo',
    ],
    athletesForGroup: () => [ATHLETES.athletesForGroup, 'athletesForGroup'],
  },
  clubs: {
    many: () => [CLUBS.manyQuery, 'clubs'],
    one: () => [CLUBS.oneQuery, 'club'],
    create: () => [CLUBS.createMutation, 'createClub'],
    update: () => [CLUBS.updateMutation, 'updateClub'],
    delete: () => [CLUBS.deleteMutation, 'deleteClub'],
  },
  gyms: {
    many: () => [GYMS.manyQuery, 'gyms'],
    one: () => [GYMS.oneQuery, 'gym'],
    create: () => [GYMS.createMutation, 'createGym'],
    update: () => [GYMS.updateMutation, 'updateGym'],
    delete: () => [GYMS.deleteMutation, 'deleteGym'],
  },
  groups: {
    many: () => [GROUPS.manyQuery, 'groups'],
    one: () => [GROUPS.oneQuery, 'group'],
    create: () => [GROUPS.createMutation, 'createGroup'],
    update: () => [GROUPS.updateMutation, 'updateGroup'],
    delete: () => [GROUPS.deleteMutation, 'deleteGroup'],
  },
  users: {
    many: () => [USERS.manyQuery, 'allUsers'],
    one: () => [USERS.oneQuery, 'user'],
    update: () => [USERS.updateMutation, 'updatePermissions'],
    delete: () => [USERS.deleteMutation, 'deleteAthlete'],
  },
  permissions: {
    many: () => [PERMISSIONS.manyQuery, 'permissions'],
  },
  ranks: {
    kyus: () => [COMMON.kyuQuery, 'kyuRanks'],
    dans: () => [COMMON.danQuery, 'danRanks'],
    ranks: () => [COMMON.ranksQuery, 'ranks'],
  },
  common: {
    sections: () => [COMMON.sectionsQuery, 'sections'],
  },
  contributions: {
    many: () => [CONTRIBUTIONS.manyQuery, 'contributions'],
    one: () => [CONTRIBUTIONS.oneQuery, 'contribution'],
    create: () => [CONTRIBUTIONS.createMutation, 'createContribution'],
    createBulk: () => [
      CONTRIBUTIONS.createBulkMutation,
      'createBulkContribution',
    ],
    update: () => [CONTRIBUTIONS.updateMutation, 'updateContribution'],
    delete: () => [CONTRIBUTIONS.deleteMutation, 'deleteContribution'],
    contributionUserList: () => [
      CONTRIBUTIONS.contributionUserListQuery,
      'contributionUserList',
    ],
    contributionTrainerList: () => [
      CONTRIBUTIONS.contributionTrainerListQuery,
      'contributionTrainerList',
    ],
    contributionAvailableGymsList: () => [
      CONTRIBUTIONS.contributionAvailableGymsListQuery,
      'contributionAvailableGymsList',
    ],
  },
  parents: {
    many: () => [PARENTS.manyQuery, 'parents'],
    one: () => [PARENTS.oneQuery, 'parent'],
    create: () => [PARENTS.createMutation, 'createParent'],
    update: () => [PARENTS.updateMutation, 'updateParent'],
    delete: () => [PARENTS.deleteMutation, 'deleteParent'],
  },
  activities: {
    many: () => [ACTIVITIES.manyQuery, 'activities'],
  },
};

export default schema;
